import dayjs from "dayjs";

const FIELD_ERROR_TEXT = "This field is required";
const COMPONENT_ERROR_TEXT = "One or more entries has an error.";

const SERVER_BASE_URL =
  "https://server-10098475446.catalystappsail.com/api/broker";
const ORGANIZATION_ID = "RECPROTECT";

const PRIMARY_COLOR = "#8ed1fc";
const WARNING_COLOR = "#e31d23";
const ERROR_HELPERTEXT_STYLES = {
  color: WARNING_COLOR,
  fontSize: ".75rem",
  lineHeight: "1rem",
  fontFamily: "Montserrat",
};

const NUMBER_REGEX = /^\d*$/;
const postalCodeRegex = /^[A-Z]\d[A-Z] \d[A-Z]\d$/;
const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
const upperCaseEmailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;

const PROVINCES_LIST = [
  {
    label: "Alberta",
    value: "Alberta",
  },
  {
    label: "British Columbia",
    value: "British Columbia",
  },
  {
    label: "Manitoba",
    value: "Manitoba",
  },
  {
    label: "New Brunswick",
    value: "New Brunswick",
  },
  {
    label: "Newfoundland and Labrador",
    value: "Newfoundland and Labrador",
  },
  {
    label: "Nova Scotia",
    value: "Nova Scotia",
  },
  {
    label: "Northwest Territories",
    value: "Northwest Territories",
  },
  {
    label: "Nunavut",
    value: "Nunavut",
  },
  {
    label: "Ontario",
    value: "Ontario",
  },
  {
    label: "Prince Edward Island",
    value: "Prince Edward Island",
  },
  {
    label: "Quebec",
    value: "Quebec",
  },
  {
    label: "Saskatchewan",
    value: "Saskatchewan",
  },
  {
    label: "Yukon",
    value: "Yukon",
  },
];

const FORM_DATA = {
  register_as: "Complete Registration Online",
  download_op_name: "",
  download_legal_broker_name: "",
  download_gen_email: "",
  download_ho_phone: "",
  legal_name_of_brokage: "",
  operating_name: "",
  ho_phone_number: "",
  ho_street: "",
  ho_line2: "",
  ho_city: "",
  ho_province: "",
  ho_pc: "",
  ho_country: "Canada",
  is_ho_the_branch: false,
  list_of_branches: [
    {
      key: "1",
      branch_name: "",
      address: "",
      line2: "",
      country: "Canada",
      city: "",
      province: "",
      postal_code: "",
      phone: "",
    },
  ],
 a_name : "",
 a_email : "",
 a_phoneNumber : "",
  contracts: [{ key: "1", company_name: "", date_appointed: "" }],
  no_mga: false,
  mga: [{ key: "1", mga_name: "", annual_premium: "" }],
  pl_first_name: "",
  pl_last_name: "",
  pl_title: "",
  pl_email: "",
  pl_phone: "",
  cra_first_name: "",
  cra_last_name: "",
  cra_title: "",
  cra_email: "",
  cra_phone: "",
  acc_first_name: "",
  acc_last_name: "",
  acc_title: "",
  acc_email: "",
  acc_phone: "",
  marketing_email: "",
  product_training_email: "",
  consent_forward: false,
  general_email: "",
  user_accounts: [
    {
      key: "1",
      first_name: "",
      last_name: "",
      email: "",
      title: "",
      branch_city: "",
    },
  ],
  eo_insurer: "",
  eo_policy: "",
  eo_limit: "",
  eo_limit_referral: false,
  eo_expiry_date: "",
  has_eando_claims_in_last_5years: "",
  eando_claim_details: "",
  cyber_insurer: "",
  cyber_limit: "",
  licensing: [
    {
      key: "1",
      province: "",
      license: "",
      expiry_date: "",
    },
  ],
  any_licensce_suspended: "",
  suspended_details: "",
  brokerage_reprimanded_in_5years: "",
  reprimand_details: "",
  terms_agreed: false,
  first_name: "",
  last_name: "",
  title: "",
  date: dayjs(),
};

const ERROR_FIELDS = {
  register_as: false,
  download_op_name: false,
  download_legal_broker_name: false,
  download_gen_email: false,
  download_ho_phone: false,
  legal_name_of_brokage: false,
  ho_phone_number: false,
  ho_street: false,
  ho_city: false,
  ho_province: false,
  ho_pc: false,
  ho_country: false,
  a_name : false,
  a_email: false,
  a_phoneNumber : false,
  list_of_branches: [
    {
      key: "1",
      branch_name: undefined,
      address: undefined,
      country: false,
      city: undefined,
      province: undefined,
      postal_code: undefined,
      phone: undefined,
    },
  ],
  contracts: [{ key: "1", company_name: undefined, date_appointed: undefined }],
  mga: [{ key: "1", mga_name: undefined, annual_premium: undefined }],
  pl_first_name: false,
  pl_last_name: false,
  pl_title: false,
  pl_email: false,
  pl_phone: false,
  cra_first_name: false,
  cra_last_name: false,
  cra_title: false,
  cra_email: false,
  cra_phone: false,
  acc_first_name: false,
  acc_last_name: false,
  acc_title: false,
  acc_email: false,
  acc_phone: false,
  marketing_email: false,
  product_training_email: false,
  consent_forward: false,
  general_email: false,
  user_accounts: [
    {
      key: "1",
      first_name: undefined,
      last_name: undefined,
      email: undefined,
      title: undefined,
      branch_city: undefined,
    },
  ],
  eo_insurer: false,
  eo_policy: false,
  eo_limit: false,
  eo_expiry_date: false,
  cyber_insurer: false,
  cyber_limit: false,
  licensing: [
    {
      key: "1",
      province: undefined,
      license: undefined,
      expiry_date: undefined,
    },
  ],
  has_eando_claims_in_last_5years: false,
  eando_claim_details: false,
  any_licensce_suspended: false,
  suspended_details: false,
  brokerage_reprimanded_in_5years: false,
  reprimand_details: false,
  terms_agreed: false,
  first_name: false,
  last_name: false,
  title: false,
  date: false,
};

const error_check_fn = ({
  required_fields = [],
  required_subform = [],
  required_checkbox = [],
  required_email = [],
  required_phone = [],
  required_pc = [],
  data,
  error,
  setError,
}) => {
  let is_valid = true;
  let error_clone = { ...error };

  //check normal inputs
  required_fields.map((item) => {
    if (data[item] && data[item].trim()) {
       error_clone = { ...error_clone, [item]: false };
    } else {
      error_clone = { ...error_clone, [item]: true };

      is_valid = false;
    }
  });

  // //check subform line item, atleast one field is filled
  // required_subform.map((m) => {
  //   let check_one_field_filled = data[m].every((item) => {
  //     return Object.entries(item).every(([key, value]) => value);
  //   });

  //   if (!check_one_field_filled) {
  //     error_clone = { ...error_clone, [m]: true };
  //     is_valid = false;
  //   } else {
  //     error_clone = { ...error_clone, [m]: false };
  //   }
  // });

  required_email.map((item) => {
    if (data[item] && data[item].trim()) {
      if (!emailRegex.test(data[item])) {
        error_clone = { ...error_clone, [item]: true };

        is_valid = false;
      } else {
        error_clone = { ...error_clone, [item]: false };
      }
    } else {
      error_clone = { ...error_clone, [item]: true };

      is_valid = false;
    }
  });

  required_phone.map((item) => {
    if (data[item] && data[item].trim()) {
      if (data[item].length !== 14) {
        error_clone = { ...error_clone, [item]: true };
        is_valid = false;
      } else {
        error_clone = { ...error_clone, [item]: false };
      }
    } else {
      error_clone = { ...error_clone, [item]: true };
      is_valid = false;
    }
  });

  required_pc.map((item) => {
    if (data[item] && data[item].trim()) {
      if (!postalCodeRegex.test(data[item])) {
        error_clone = { ...error_clone, [item]: true };
        is_valid = false;
      } else {
        error_clone = { ...error_clone, [item]: false };
      }
    } else {
      error_clone = { ...error_clone, [item]: true };
      is_valid = false;
    }
  });

  required_subform.map((item) => {
    let is_any_undefined = error_clone[item].some((item) => {
      return Object.values(item).some((value) => value === undefined);
    });

    if (is_any_undefined) {
      is_valid = false;

      error_clone[item].map((item) => {
        for (const key in item) {
          if (item[key] === undefined) {
            item[key] = true;
          }
        }
      });
    }

    let is_any_true = error_clone[item].some((item) => {
      return Object.values(item).some((value) => value === true);
    });

    if (is_any_true) {
      is_valid = false;
    }
  });

  required_checkbox.map((item) => {
    if (!data[item]) {
      error_clone = { ...error_clone, [item]: true };
      is_valid = false;
    } else {
      error_clone = { ...error_clone, [item]: false };
    }
  });

  setError(error_clone);

  return is_valid;
};

const subform_error_check_fn = ({
  required_fields = [],
  data,
  error,
  setError,
}) => {
  let is_valid = true;
  let error_clone = { ...error };

  setError(error_clone);

  return is_valid;
};

const subformInputChange = ({
  value = "",
  key = "",
  name = "",
  object_key = "",
  data = {},
  setData,
  custom = "",
  error = {},
  setError,
  type = "",
}) => {
  // if (custom === "phone") {
  //   if (!NUMBER_REGEX.test(value)) return;
  //    else if (value.length !== 10) {
  //     let map = data[object_key].map((item) => {
  //       if (item.key === key) {
  //         return { ...item, [name]: value };
  //       }

  //       return item;
  //     });

  //     let error_map = error[object_key].map((item) => {
  //       if (item.key === key) {
  //         if (item.hasOwnProperty(name)) return { ...item, [name]: true };
  //       }

  //       return item;
  //     });

  //     setError({ ...error, [object_key]: error_map });
  //     setData({ ...data, [object_key]: map });
  //   } else {
  //     let map = data[object_key].map((item) => {
  //       if (item.key === key) {
  //         return { ...item, [name]: value };
  //       }

  //       return item;
  //     });

  //     let error_map = error[object_key].map((item) => {
  //       if (item.key === key) {
  //         if (item.hasOwnProperty(name)) return { ...item, [name]: false };
  //       }

  //       return item;
  //     });

  //     setError({ ...error, [object_key]: error_map });
  //     setData({ ...data, [object_key]: map });
  //   }

  //   return;
  // }
  //krishnaja
   if(custom === "street address" || custom === "line2" || custom === "city"){
    console.log("custom");
      value = value.replace(/,/g, " ");
   }
  if (custom === "phone") {
    if (value.length > 14) {
      return;
    }

    let map = data[object_key].map((item) => {
      if (item.key === key) {
        let formattedValue = value;
        let NumOnly = value.replace(/\D/g, "");
        formattedValue = NumOnly;

        if (NumOnly.length <= 3) {
          formattedValue = `(${NumOnly}`;
        } else if (NumOnly.length <= 6) {
          formattedValue = `(${NumOnly.slice(0, 3)}) ${NumOnly.slice(3)}`;
        } else if (NumOnly.length <= 10) {
          formattedValue = `(${NumOnly.slice(0, 3)}) ${NumOnly.slice(
            3,
            6
          )}-${NumOnly.slice(6)}`;
        }

        return { ...item, [name]: formattedValue };
      }

      return item;
    });

    let error_map = error[object_key].map((item) => {
      if (item.key === key) {
        if (item.hasOwnProperty(name)) return { ...item, [name]: false };
      }

      return item;
    });

    if (type !== "admin") {
      setError({ ...error, [object_key]: error_map });
    }
    setData({ ...data, [object_key]: map });

    return;
  } //phone only

  if (custom === "postal_code") {
    let map = data[object_key].map((item) => {
      if (item.key === key) {
        return { ...item, [name]: value };
      }

      return item;
    });

    let error_map;

    if (postalCodeRegex.test(value)) {
      error_map = error[object_key].map((item) => {
        if (item.key === key) {
          if (item.hasOwnProperty(name)) return { ...item, [name]: false };
        }

        return item;
      });
    } else {
      error_map = error[object_key].map((item) => {
        if (item.key === key) {
          if (item.hasOwnProperty(name)) return { ...item, [name]: true };
        }

        return item;
      });
    }

    if (type !== "admin") {
      setError({ ...error, [object_key]: error_map });
    }
    setData({ ...data, [object_key]: map });

    return;
  }

  if (custom === "number") {
    if (!NUMBER_REGEX.test(value)) return;
  }

  if (custom === "date") {
    let map = data[object_key].map((item) => {
      if (item.key === key) {
        return { ...item, [name]: value };
      }

      return item;
    });

    let error_map = error[object_key].map((item) => {
      if (item.key === key) {
        if (item.hasOwnProperty(name)) return { ...item, [name]: false };
      }

      return item;
    });

    if (type !== "admin") {
      setError({ ...error, [object_key]: error_map });
    }
    setData({ ...data, [object_key]: map });
    return;
  }

  if (custom === "email") {
    if (!emailRegex.test(value)) {
      let map = data[object_key].map((item) => {
        if (item.key === key) {
          return { ...item, [name]: value };
        }

        return item;
      });

      let error_map = error[object_key].map((item) => {
        if (item.key === key) {
          if (item.hasOwnProperty(name)) return { ...item, [name]: true };
        }

        return item;
      });

      if (type !== "admin") {
        setError({ ...error, [object_key]: error_map });
      }
      setData({ ...data, [object_key]: map });
    } else {
      let map = data[object_key].map((item) => {
        if (item.key === key) {
          return { ...item, [name]: value };
        }

        return item;
      });

      let error_map = error[object_key].map((item) => {
        if (item.key === key) {
          if (item.hasOwnProperty(name)) return { ...item, [name]: false };
        }

        return item;
      });

      if (type !== "admin") {
        setError({ ...error, [object_key]: error_map });
      }
      setData({ ...data, [object_key]: map });
    }

    return;
  }

  let map = data[object_key].map((item) => {
    if (item.key === key) {
      return { ...item, [name]: value };
    }

    return item;
  });

  let error_map;
  if (value.trim()) {
    error_map = error[object_key].map((item) => {
      if (item.key === key) {
        if (item.hasOwnProperty(name)) return { ...item, [name]: false };
      }

      return item;
    });
  } else {
    error_map = error[object_key].map((item) => {
      if (item.key === key) {
        if (item.hasOwnProperty(name)) return { ...item, [name]: true };
      }

      return item;
    });
  }

  if (type !== "admin") {
    setError({ ...error, [object_key]: error_map });
  }
  setData({ ...data, [object_key]: map });
};

const error_state_check_fn = (value, type = "text") => {
  if (type === "text") {
    if (value && value.trim()) {
      return false;
    }

    return true;
  } else if (type === "checkbox") {
    if (value === true || value === false) {
      return false;
    }

    return true;
  } else if (type === "yes_or_no") {
    if (value === true || value === false) {
      return false;
    }

    return true;
  }
};

const steps_array = [
  { page: 1, percent: 0 },
  { page: 2, percent: 30 },
  { page: 3, percent: 40 },
  { page: 4, percent: 50 },
  { page: 5, percent: 70 },
  { page: 6, percent: 80 },
  { page: 7, percent: 90 },
  { page: 8, percent: 100 },
];

export {
  FIELD_ERROR_TEXT,
  COMPONENT_ERROR_TEXT,
  ERROR_HELPERTEXT_STYLES,
  PRIMARY_COLOR,
  WARNING_COLOR,
  FORM_DATA,
  error_check_fn,
  subformInputChange,
  ERROR_FIELDS,
  subform_error_check_fn,
  NUMBER_REGEX,
  postalCodeRegex,
  emailRegex,
  steps_array,
  SERVER_BASE_URL,
  ORGANIZATION_ID,
  error_state_check_fn,
  PROVINCES_LIST,
  upperCaseEmailRegex,
};
